const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const fetchInventarioVertical = async (filters = {}) => {
  try {
    const response = await fetch(`${API_URL}/inventario-lenceria-vertical/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });

    if (!response.ok) {
      throw new Error('Error al obtener inventario vertical');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchInventarioVertical:', error);
    throw error;
  }
};

export const fetchInventarioVerticalByEdificio = async (edificioId) => {
  try {
    const response = await fetch(`${API_URL}/inventario-lenceria-vertical/edificio/${edificioId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al obtener inventario del edificio');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchInventarioVerticalByEdificio:', error);
    throw error;
  }
};

export const createInventarioVertical = async (data) => {
  try {
    const response = await fetch(`${API_URL}/inventario-lenceria-vertical/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('Error al crear inventario vertical');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en createInventarioVertical:', error);
    throw error;
  }
};

export const updateInventarioVertical = async (id, data) => {
  try {
    const response = await fetch(`${API_URL}/inventario-lenceria-vertical/update/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('Error al actualizar inventario vertical');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en updateInventarioVertical:', error);
    throw error;
  }
};

export const deleteInventarioVertical = async (id) => {
  try {
    const response = await fetch(`${API_URL}/inventario-lenceria-vertical/delete/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al eliminar inventario vertical');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en deleteInventarioVertical:', error);
    throw error;
  }
};

export const ajustarStockVertical = async (id, cantidad, tipo) => {
  try {
    const response = await fetch(`${API_URL}/inventario-lenceria-vertical/ajustar-stock/${id}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ cantidad, tipo }),
    });

    if (!response.ok) {
      throw new Error('Error al ajustar stock vertical');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en ajustarStockVertical:', error);
    throw error;
  }
};

export const fetchTotalesPorEdificios = async (edificioIds) => {
  try {
    const response = await fetch(`${API_URL}/inventario-lenceria-vertical/totales-por-edificios`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ edificioIds }),
    });

    if (!response.ok) {
      throw new Error('Error al obtener totales por edificios');
    }

    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error('Error en fetchTotalesPorEdificios:', error);
    throw error;
  }
};
